module.exports = __webpack_public_path__ + "img/logo-cer-01.39681960.png";